import React from 'react';
import { MarkdownBlock } from '../../../MarkdownBlock';
import { styles } from './ShippingTab.css';

export type ShippingTabProps = {
  shippingMarkdown: string;
};

export const ShippingTab = ({ shippingMarkdown }: ShippingTabProps) => {
  return <MarkdownBlock className={styles.sellerContentTabContainer}>{shippingMarkdown}</MarkdownBlock>;
};
